<template>

  <v-row>
    <v-col
      cols="12"
      md="3"
    >
      <v-text-field
        v-model="address.street"
        label="Street *"
        :rules="[rules.required]"
        required
        outlined
        :disabled="disabled"
        :hide-details="disabled"
      ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      md="3"
    >
      <v-text-field
        v-model="address.city"
        label="City *"
        :rules="[rules.required]"
        required
        outlined
        :disabled="disabled"
        :hide-details="disabled"
      ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      md="3"
    >
      <v-row no-gutters class="flex-nowrap">
        <v-text-field
          v-model="address.zipcode"
          :rules="[rules.required]"
          label="Zipcode *"
          required
          type="tel"
          outlined
          :disabled="disabled"
          :hide-details="disabled"
        ></v-text-field>
        <v-btn v-if="!disabled" class="mt-2 ml-2" icon color="warning" @click="remove(i)"><v-icon>delete</v-icon></v-btn>
      </v-row>
    </v-col>
  </v-row>

</template>

<script>

export default {
  name: "CustomerAddress",
  props: ['address', 'rules', 'remove', "i", "disabled"] 
};
</script>